import { observer } from "mobx-react";
import { useEffect } from "react";
import ReportsStore from "../../store/ReportsStore";
import UserStore from "../../store/UserStore";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import { getMonth, getSecond } from "../../utils/functions";

import Modal from "../../components/Modal";
import { errorModalPadding, fileDownloadingMessage } from "../../utils/constants";
import AllErrorModalUGL from "../../components/ModalFamily/AllErrorModalUGL";

const DownloadFile = () => {
  const userHydrated = UserStore.isHydrated;
  useEffect(() => {
    if (UserStore.isHydrated) {

      // After hydration , get all the required parameters and trigger the API call , 
      // On Success of API call set the cookie and close the window
      // On failure set the error state to show the error modal
      // Then in allRoutes check for the cookie and download the file and clear the cookie 

      const time = "T00:00:00+05:30";
      const fromDate = UserStore.taxFromDate;
      const toDate = UserStore.taxToDate;
      const todaysDate = new Date();
      ReportsStore.downloadPdf(
        `${fromDate.year}-${fromDate?.month}-${fromDate.date}${time}`,
        `${toDate.year}-${toDate?.month}-${toDate.date}${time}`,
        `${todaysDate.getFullYear()}-${getMonth(
          todaysDate.getMonth()
        )}-${getSecond(todaysDate.getDate())}T${getSecond(
          todaysDate.getHours()
        )}:${getSecond(todaysDate.getMinutes())}:${getSecond(
          todaysDate.getSeconds()
        )}+05:30`
      );
    }
  }, [userHydrated]);

  return (
    <div>
      {!UserStore?.taxReportDownloadError && (
        <div className="loading_screen taxloading">
          <p>{fileDownloadingMessage}</p>
          <img className="loading_gif" src={loaderGIF} alt="loading..." />
        </div>
      )}
      <Modal
        modalStyle={errorModalPadding}
        showCloseIcon={true}
        open={
          UserStore?.taxReportDownloadError === 500 ||
          UserStore?.taxReportDownloadError === 204
        }
        onClose={() => {
          UserStore.setTaxReportDownloadError(false);
          window.close();
        }}
      >
        <AllErrorModalUGL
          msg={UserStore?.taxReportDownloadError === 500
            ? "Something went wrong, Please try again after sometime."
            : "No data available for the selected date range. Please try selecting a different period"}
          onConfirm={() => window.close()}
        />
      </Modal>
    </div>
  );
};

export default observer(DownloadFile);
